/**
 * Created by Administrator on 2018/8/24 0024.
 */

import { axiosInstance, axiosTokenInstance } from './../axios'

let userPath = {
  level1:'co',
  level2:'index'
}

// 商品接口
export async function slideShow () {
  return axiosInstance.get(`/${userPath.level1}/${userPath.level2}/slideShow`)
}

export async function goods () {
  return axiosInstance.get(`/${userPath.level1}/${userPath.level2}/goods`)
}
export async function goodsDetail (goodsSn) {
  return axiosInstance.get(`/${userPath.level1}/${userPath.level2}/goods/${goodsSn}`)
}





// WEBPACK FOOTER //
// ./src/api/interface/common.js